import { Image } from 'src/app/interfaces/image';

export const IMAGES: Image[] = [
  {
    imageId: 1234,
    imageDescription: 'otra imagen',
    imagePath: 'uploads/image-1620736457737.jpg',
  },
];
